const { NETWORK_NAME_LABELS, PAYMENT_STATES_LABELS } = require('src/utils/constants');
const { dateToFormattedStr } = require('src/utils/dates');
const { removeTrailingZeros } = require('src/utils/strings');

const LargePaymentsTable = ({ transactions }) => (
    <table className="w-full bg-gray-light rounded-t-xl overflow-hidden mt-6">
        <thead>
            <tr className="bg-gray-lighter">
                <th className="text-left text-gray-darker font-medium text-xs py-4 pl-2 lg:pl-8">Date</th>
                <th className="text-left text-gray-darker font-medium text-xs py-4">Network</th>
                <th className="text-left text-gray-darker font-medium text-xs py-4">Customer</th>
                <th className="text-left text-gray-darker font-medium text-xs py-4">Products</th>
                <th className="text-left text-gray-darker font-medium text-xs py-4 pr-8">Amount</th>
                <th className="text-left text-gray-darker font-medium text-xs py-4">USD Amount</th>
                <th className="text-left text-gray-darker font-medium text-xs py-4 pr-0 lg:pr-8">Status</th>
            </tr>
        </thead>
        <tbody>
            {transactions.map((transaction, i) => (
                <tr key={i}>
                    <td className="py-4 pl-2 lg:pl-8">{dateToFormattedStr(new Date(transaction.createdAt))}</td>
                    <td className="py-4">{NETWORK_NAME_LABELS[transaction.network]}</td>
                    <td className="py-4">
                        <div className="flex flex-col items-start justify-center">
                            <span className="text-gray-darker text-xs">
                                {transaction.customerFirstName} {transaction.customerLastName}
                            </span>
                            <span>{transaction.customerEmail}</span>
                        </div>
                    </td>
                    <td className="py-4">{transaction.productNames.join(', ')}</td>
                    <td className="py-4 pr-8">
                        {removeTrailingZeros(parseFloat(transaction.tokenAmount).toFixed(8))}&nbsp;
                        {transaction.coin}
                    </td>
                    <td className="py-4">${transaction.costInUSD}</td>
                    <td className="py-4 text-xs">{PAYMENT_STATES_LABELS[transaction.status]}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

export default LargePaymentsTable;
